import { tsValidateArray, tsValidateBoolean, tsValidateOptionalId, tsValidateOptionalObject, tsValidateString, tsValidateTimestamp, tsValidateUniqueId, tsValidateValue, } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DataTypes } from './bucket-dump-types.js';
import { EncounterEventTypes, } from './types.js';
const Validator_BucketMetadata = {
    bucketPath: tsValidateString(),
    bucketName: tsValidateString(),
    projectId: tsValidateString(-1, false),
    dataType: tsValidateValue([...DataTypes], false),
};
const Validator_BaseEncounterEvent = {
    encounterId: tsValidateUniqueId,
    patientId: tsValidateUniqueId,
    encounterDataId: tsValidateUniqueId,
};
// Polymorphic event: eventType required, event-specific fields optional so any variant passes
const Validator_MandatoryPropsEncounterEvent = {
    eventType: tsValidateValue([...EncounterEventTypes]),
    title: tsValidateString(-1, false),
    assignedTimestamp: tsValidateTimestamp(),
    createdFromSnapshotId: tsValidateOptionalId,
    // order event fields
    orderId: tsValidateOptionalId,
    orderName: tsValidateString(-1, false),
    // bug report event fields
    linkToBugReportData: tsValidateString(-1, false),
    description: tsValidateString(-1, false),
    files: tsValidateArray({ name: tsValidateString(), path: tsValidateString() }, false),
    // pathway event fields
    pathwayId: tsValidateOptionalId,
    pathwayLabel: tsValidateString(-1, false),
    // finding event fields
    variableId: tsValidateOptionalId,
    findingLabel: tsValidateString(-1, false),
    isChiefComplaint: tsValidateBoolean(false),
    // snapshot event fields
    bucketMetadata: tsValidateOptionalObject(Validator_BucketMetadata),
    ...Validator_BaseEncounterEvent,
};
const Validator_GeneratedProps = {};
export const DBDef_EncounterEvent = {
    modifiablePropsValidator: Validator_MandatoryPropsEncounterEvent,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'encounter-events',
    generatedProps: [],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'encounter-events',
    },
    backend: {
        name: 'encounter-events',
    },
    entityName: 'EncounterEvents',
    dependencies: {
        'encounterDataId': {
            dbKey: 'encounters-data',
            fieldType: 'string',
        },
    },
};
//# sourceMappingURL=db-def.js.map